// Module
var code = "<div ui-view></div> <div ui-view=\"vlastnici\"></div> ";
// Exports
module.exports = code;